// extracted by mini-css-extract-plugin
export default {"inputWrapper":"SelectInput_inputWrapper__3Fruc","label":"SelectInput_label__e4zDe","select":"SelectInput_select__Dk+uP","errorMessage":"SelectInput_errorMessage__jf9ca"};